import { Box } from '@wix/design-system';
import { CheckoutSkeleton } from '@wix/premium-purchase-platform/@ui';
import React from 'react';
import s from './CheckoutLoadingSkeleton.scss';
const DESKTOP_WIDTH = '1058px';
const MOBILE_PAGE_SIDE_PADDING = '36px';
const MOBILE_WIDTH = `calc(100vw - ${MOBILE_PAGE_SIDE_PADDING})`;
export const CheckoutLoadingSkeleton = _ref => {
  let {
    isMobile = false
  } = _ref;
  return /*#__PURE__*/React.createElement(Box, {
    dataHook: "checkout-loading-skeleton",
    boxSizing: "border-box",
    paddingBottom: "SP6",
    width: isMobile ? MOBILE_WIDTH : DESKTOP_WIDTH,
    maxWidth: "100%",
    className: !isMobile ? s.gradientFill : ''
  }, /*#__PURE__*/React.createElement(CheckoutSkeleton, null));
};
//# sourceMappingURL=CheckoutLoadingSkeleton.js.map